const { UPDATE_HOSPITALWARDLIST, DELETE_HOSPITALWARDLIST } = require('../../constant');

const updateHospitalWardListAction = (data) => ({
  type: UPDATE_HOSPITALWARDLIST,
  data,
});

const deleteHospitalWardListAction = (data) => ({
  type: DELETE_HOSPITALWARDLIST,
  data: null,
});

export { updateHospitalWardListAction, deleteHospitalWardListAction };
